module.exports = __webpack_public_path__ + "img/iphoneplus_splash.ebaaff3e.png";